import * as React from 'react';
import { Moment } from 'moment';
import styled from 'styled-components';

interface props {
  startDate: Moment;
  endDate: Moment;
}

const PickupDropoffText = styled.p`
  font-style: normal;
  font-weight: bold;
  font-size: 11px;
  color: #828282;
  margin-bottom: 0;
`;

const DateText = styled.p`
  font-size: 14px;
  margin-bottom: 0;
  color: #333333;
  margin-bottom: 0;
  margin-top: 5px;
`;

const DateDropoffPickupContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;

const DateContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const DateDropoffPickup = (props: props) => {
  return (
    <DateDropoffPickupContainer>
      <DateContainer>
        <PickupDropoffText>Dropoff Date</PickupDropoffText>
        <DateText>{props.startDate.format('M/D/YY')}</DateText>
      </DateContainer>
      <DateContainer>
        <PickupDropoffText>Pickup Date</PickupDropoffText>
        <DateText>{props.endDate.format('M/D/YY')}</DateText>
      </DateContainer>
    </DateDropoffPickupContainer>
  );
};

export default DateDropoffPickup;



// WEBPACK FOOTER //
// ./src/components/MatchComponents/DateDropoffPickup.tsx